import React from 'react';

export const SponsorConfig = {
    settings: {
        layout: {
            config: {
                header: { display: true },
                footer: { display: true },
                navbar: { display: true },
            },
        },
    },
    isPrivate: true,
    eventName: 'sponsor_booth',
    routes: [
        {
            path: '/:organizationId/:eventSlug/sponsor',
            component: React.lazy(() => import('./Sponsor')),
        },
    ],
};
